import { Link, RouteComponentProps, useParams } from '@reach/router'
import { Layout } from 'antd'
import React from 'react'
import styled from 'styled-components'
import hero from '../assets/hero.jpg'
import { ROOT_PATH } from '../common/config'
import { ForgotPassword, ForgotPasswordProvider } from '../components/ForgotPassword'
import { ForgotUser, ForgotProvider } from '../components/ForgotUser'
import { Brand, HeroIntro } from '../components/ui'

const { Sider, Content } = Layout

const StyledUser = styled.div`
  h1 {
    font-weight: 500;
    font-size: 32px !important;
    line-height: 38px;
    color: #262626;
    margin-top: 120px;
    margin-bottom: 100px;
  }

  .user-left {
    background: linear-gradient(rgba(77, 70, 70, 0.3), rgba(77, 70, 70, 0.3)), url(${hero}) no-repeat center / cover;

    h1 {
      margin-bottom: 1em !important;
    }
  }

  .user-content {
    height: calc(var(--vh) * 100);
    width: 100%;
    padding: 0 120px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    background-color: #f9bb19;
  }

  .btn-groups {
    margin-top: auto;
    width: 100%;
  }

  @media screen and (max-width: 600px) {
    .user-content {
      padding: 0 30px;
    }
  }
`

export const Forgot: React.FC<RouteComponentProps> = () => {
  const { type } = useParams()
  const ForgotContent = type === 'username' ? ForgotUser : ForgotPassword

  return (
    <ForgotProvider>
      <ForgotPasswordProvider>
        <StyledUser>
          <Layout className="page h-mscreen">
            <Link to={ROOT_PATH}>
              <Brand className="absolute bg-white top-0 left-10 p-5 z-10" />
            </Link>
            <Sider width="55%" className="user-left hidden sm:block">
              <HeroIntro className="h-4/6" />
            </Sider>
            <Content className="user-content">
              <ForgotContent />
            </Content>
          </Layout>
        </StyledUser>
      </ForgotPasswordProvider>
    </ForgotProvider>
  )
}
